import React from "react";

import { LayerDeleteAction, LayerDrawAction, LayerUploadAction } from "fond/project/panels/InputPanel/actions";
import LayerPanel from "fond/project/panels/InputPanel/LayerPanel";

import { useDesignEdits } from "../hooks/useDesignEdits";
import { useDesignRefinementActions } from "../hooks/useDesignRefinementActions";

/**
 * Stacked navigation panel for editing the blockers of a completed design.
 */
const BlockersRefinementPanel: React.FC = () => {
  const { hasBlockers } = useDesignEdits();
  const { deleteBlockers } = useDesignRefinementActions();

  return (
    <LayerPanel title="Blockers" layerKey="extended-design-blockers">
      <LayerDrawAction />
      <LayerUploadAction />
      {hasBlockers && <LayerDeleteAction onDelete={deleteBlockers} />}
    </LayerPanel>
  );
};

export default BlockersRefinementPanel;
